"use client";

import { Icons } from "@/components/icons/icons";
import ProjectOfflineState from "@/components/ProjectOfflineState";
import StoneLogo from "@/components/StoneLogo";
import { useEffect, useState } from "react";
import { wakeAzure } from "@/lib/wake-azure";

const RETRY_WINDOW_MS = 30_000;
const RETRY_DELAY_MS = 2_000;
const SESSION_KEY = "widget-retry-start";

export default function WidgetError({
  unstable_retry,
}: {
  error: Error & { digest?: string };
  // Refetches the server render; plain `reset` would replay the same error.
  unstable_retry: () => void;
}) {
  const [gaveUp] = useState(() => {
    try {
      const stored = sessionStorage.getItem(SESSION_KEY);
      if (!stored) {
        sessionStorage.setItem(SESSION_KEY, String(Date.now()));
        return false;
      }
      return Date.now() - Number(stored) > RETRY_WINDOW_MS;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    wakeAzure();

    if (gaveUp) {
      try {
        sessionStorage.removeItem(SESSION_KEY);
      } catch {}
      return;
    }
    const timer = setTimeout(unstable_retry, RETRY_DELAY_MS);
    return () => clearTimeout(timer);
  }, [unstable_retry, gaveUp]);

  if (gaveUp) {
    return (
      <ProjectOfflineState message="This recording is temporarily unavailable. Please try again later." />
    );
  }

  return (
    <div className="w-full flex gap-4 items-center justify-center h-full">
      <StoneLogo />
      <Icons.spinner className="h-12 w-12 animate-spin" />
    </div>
  );
}
